/** Cebuano for the constituent-facing parts of the registry and card desk (PIN, consent, card tap) and Help. */
export const CEB_REGISTRY: Record<string, string> = {
  "Choose a 4-digit PIN": "Pagpili og 4-digit PIN",
  "Type the same PIN again": "I-type pag-usab ang samang PIN",
  "New 4-digit PIN": "Bag-ong 4-digit PIN",
  "Avoid 1234, 0000 or your birth year.": "Likayi ang 1234, 0000 o tuig sa pagkatawo.",
  "PIN set. Turn the screen back to the staff.": "Na-set na ang PIN. Ibalik ang screen sa empleyado.",
  "Choose a different PIN": "Pagpili og laing PIN",
  "The PINs do not match.": "Dili parehas ang mga PIN.",
  "Clear": "Papasa",
  "Delete last digit": "Papasa ang katapusang numero",
  "{n} of 4 digits entered": "{n} sa 4 ka numero ang nasulod",
  "Turn the screen toward the constituent.": "Iatubang ang screen sa constituent.",
  "They choose and type their own 4-digit PIN. Staff must not look.": "Sila ang mopili ug mo-type sa ilang kaugalingong 4-digit PIN. Dili angay motan-aw ang empleyado.",
  "Face the camera, no hat or sunglasses, plain background.": "Atubanga ang camera, walay kalo o shades, yano nga background.",
  "Take photo": "Pagkuha og litrato",
  "Retake": "Kuhaa pag-usab",
  "Signature or thumbmark": "Pirma o thumbmark",
  "Optional but recommended.": "Opsyonal apan girekomendar.",
  "The person acknowledges receiving the card.": "Gidawat sa tawo ang card.",
  "Signature or thumbmark on the release log": "Pirma o thumbmark sa release log",
  "Privacy notice": "Pahibalo sa privacy",
  "Back": "Balik",
  "The constituent read (or was read) the privacy notice version {v} and agrees to the processing of their data for LGU assistance.": "Nabasa sa constituent (o gibasahan siya) ang pahibalo sa privacy bersyon {v} ug misugot sa pagproseso sa iyang datos alang sa ayuda sa LGU.",
  "Tap a card": "I-tap ang card",
  "Hold the card on the back of this phone.": "Ibutang ang card sa likod niining telepono.",
  "Checking the card…": "Gisusi ang card…",
  "This is not an LGU card, or it could not be read. Try again.": "Dili kini LGU card, o dili mabasa. Sulayi pag-usab.",
  "The card could not be read. Hold it still on the back of the phone.": "Dili mabasa ang card. Ayaw lihoka sa likod sa telepono.",
  "Help": "Tabang",
  "Search help": "Pangita sa tabang",
  "Search help, e.g. PIN, billing, lost card": "Pangita, pananglitan PIN, billing, nawala nga card",
  "Guides": "Mga giya",
  "Guides for": "Giya para sa",
  "Merchants": "Mga merchant",
  "Constituents": "Mga constituent",
  "Step-by-step guides for every part of the system.": "Giya matag lakang sa matag bahin sa sistema.",
  "No guide matches. Try another word.": "Walay giya nga mohaom. Sulayi ang laing pulong.",
  "{n} years old": "{n} ka tuig",
  "Male": "Lalaki",
  "Female": "Babaye",
};
